export const news = [
    {
        slug: 'belavia-new-destinations-vietnam',
        title: 'Белавиа не перестает удивлять нас новыми направлениями. Вьетнам как на ладони: новое направление 🌴 ',
        text: `
        <p><b>С 10 мая Belavia начинает выполнять чартерные рейсы Минск-Дананг, в один из самых живописных курортов центрального Вьетнама!</b></p>
        </br>
        <p><b>Дананг: Город мостов и бесконечных пляжей</b></p>
        <p>Дананг — это не просто точка на карте Вьетнама, а настоящая жемчужина центрального побережья. Город, где современность встречается с природной красотой, а история переплетается с динамичной жизнью мегаполиса. Если вы ищете место, способное удивить с первого взгляда, — вы его нашли.</p>        </br>
        <p><b>Мраморные горы (Ngu Hanh Son)</b></p>
        <p>Пять священных холмов из мрамора и известняка, хранящие в своих пещерах древние пагоды и буддийские святыни. Поднимитесь на вершину, и перед вами откроется панорама бескрайнего океана и города. Это место силы и умиротворения, где время замедляет свой бег.</p>
        </br>
        <p><b>Золотой мост (Cầu Vàng)</b></p>
        <p>Визитная карточка Дананга, известная на весь мир. Две гигантские каменные руки, будто вышедшие из древних легенд, поддерживают золотой пешеходный мост на высоте 1400 метров над уровнем моря. Прогулка здесь — словно путешествие в сказку, парящую над облаками.</p>
        </br>
        <p><b>Пляж Ми Кхе (My Khe Beach)</b></p>
        <p>Шестикилометровая полоса белого песка, которую журнал Forbes включил в список самых красивых пляжей планеты. Идеальное место для серфинга, рассветов с чашкой вьетнамского кофе или просто безмятежного отдыха под шум волн.</p>
        </br>
        <p><b>Музей Тямской скульптуры (Da Nang Museum of Cham Sculpture)</b></p>
        <p>Погружение в тысячелетнюю историю древнего народа тямов. Уникальные каменные изваяния богов, мифических животных и храмовые реликвии рассказывают истории давно ушедших цивилизаций.</p>
        </br>
        <p><b>Мост Дракона (Cầu Rồng)</b></p>
        <p>Каждую субботу и воскресенье вечером этот мост оживает — гигантский дракон извергает огонь и воду прямо над рекой Хан. Зрелище завораживающее и абсолютно незабываемое!</p>
        </br>
        <p>Стоимость на двоих из Минска на конец мая стартует от 7800 бел руб (стоимость актуальна на момент публикации)</p>`,
        img: ['viet1.jpg', 'viet2.jpg', 'viet3.jpg'],
    },
    {
        slug: 'turkey-mediterranean-resorts',
        title: 'Курорты Средиземноморского побережья Турции: выбираем идеальное место отдыха',
        text: `
        <p>Курорты Средиземноморского побережья Турции отличаются друг от друга пляжами, удаленностью от аэропорта и ценовой категорией отелей. Чтобы проще было сделать выбор в пользу курорта, мы подготовили для вас основную информацию по каждому из них.</p>
        </br>
        <p><b>1. Анталия (20–30 минут езды от аэропорта)</b></p>
        <p>Анталия лидирует по удобству с песчано-галечными пляжами комфортной ширины, где мелкая галька сочетается с песком для удобного входа в море. Отели преимущественно 4–5*, с развитой городской инфраструктурой и all inclusive опциями. Красивая природа с пальмами, парками и видом на горы, дополненная променадами и портом для яхт. Курорт универсальный: подходит для семейного отдыха с аквапарками, молодежного с ночными барами и деловых поездок благодаря шопингу и экскурсиям. Но нужно понимать, что отели данного курорта по ценовой политике идут выше среднего, так на раннем бронировании туров на 2026 год от 2100 евро на двоих на май.</p>
        </br>
        <p><b>2. Белек (30–40 минут)</b></p>
        <p>Белек предлагает широкие песчаные пляжи с пологим входом, идеальные для длительного отдыха. Доминируют 5* отели премиум-класса с обширными территориями и эксклюзивными услугами. Шикарная природа с хвойными лесами и дюнами, создающими тенистые зоны и свежий микроклимат даже в жару. Основной тип — семейный в большинстве своем с огромными детскими клубами и гольфом для взрослых, но универсален для пар, ищущих спокойный премиум-отдых. Ценовая категория по отелям выше среднего. Стоимость на туры на раннем бронировании в 2026 годы на качественные пятерки от 2200 евро на неделю на май.</p>
        </br>
        <p><b>3. Кемер (50–60 минут)</b></p>
        <p>Кемер известен галечными пляжами с кристально чистой водой и живописными бухтами в окружении гор. Категория отелей 3–5*, с акцентом на семейные и молодежные комплексы all inclusive. Природа удивительная: горы, сосновые рощи и каньоны обеспечивают прохладу и возможности для трекинга. Идеален для молодежного отдыха с дискотеками и активностями вроде рафтинга, но подходит семьям за счет экскурсий и спокойных бухт. Здесь можно найти отели на любой вкус и кошелек, от бюджетных но качественных 3* до премиум 5*. Стоимость на проверенные отели на май на двоих 4* от 1700 евро, 5* от 1900 евро.</p>
        </br>
        <p><b>4. Сиде (60–70 минут)</b></p>
        <p>Сиде радует длинными песчаными пляжами с бархатным покрытием и мелководьем для детей. Отели 4–5* в среднем и премиум-сегментах, с сильным семейным уклоном. Природа сочетает равнины с пальмами, античными руинами на берегу и легким бризом от моря. Преимущественно семейный с культурными программами, но универсален для пар и групп благодаря водным видам спорта и историческим сайтам. Ценовая категория все же выше среднего, так как основной акцент на отели 5*, есть несколько проверенных 4, но их не так много.</p>
        </br>
        <p><b>5. Аланья (2–2,5 часа)</b></p>
        <p>Аланья выделяется километровыми песчаными пляжами с золотистым песком и теплой лагуной. Преобладают отели 3–4*, бюджетные и средние all inclusive варианты. Природа включает скалы, пещеры у моря и цитрусовые сады, с теплым климатом и обилием солнца. Ориентирован на молодежный отдых с лунапарками и вечеринками, но универсален для семей, ищущих экономичный пляжный релакс. Стоимость на двоих на 4* от 1500 евро с вылетом из Минска.</p>
        </br>
        <p><b>Помните:</b> Все цены указаны на момент публикации с вылетом из Минска на начала сезона. Июль-август самые дорогие и жаркие месяца, сентябрь - октябрь комфортное время по температуре и чуть меньше туристов (но тенденция последних лет что отели на 80-90% заполнены даже в конце октября).</p>
        </br>
        <p>Не знаете, какой курорт и отель выбрать - доверьте свой выбор профессионалам!</p>`,
        img: ['tr1.jpg', 'tr2.jpg', 'tr3.jpg'],
    },
    {
        slug: 'new-destinations-2025-2026',
        title: 'Новые направления, которые доступны в 2025-2026 году на прямом рейсе из Минска',
        text: `
        <p>Наша Белавиа не перестает нас удивлять. С покупкой новых самолетов круг стран, доступных для путешествий в ближайшее время постепенно растет. Во-первых, на зимний период для нас открыта Азия. Летим на прямом рейсе в Таиланд, Шри-Ланку, Китай, Вьетнам (остров Фукуок), Оман.</p>
        </br>
        <p>На весну - лето тоже не меньше новых направлений. Помимо всеми любимых Турции, Египта, Эмиратов, Грузии, мы стали <a href='/news/qatar-top-places' class='news-highlight-link'>летать в Катар</a> - направление уже известное для нашего рынка и круглогодичное, хоть и с нюансами по климату. Также не первый год как полетит новый регион Египта - египетские Мальдивы (наша Екатерина, кстати, вернулась не так давно из рабочей поездки и будет рада помочь с выбором вашего идеального отеля).</p>
        </br>
        <p>Из новинок 2026 года нас ждет возвращение таких направлений как Тунис и Иордания! И это лишь те направления, которые будут летать на чартерных рейсах, помимо этого есть ряд стран, куда можно отправится на регулярном рейсе Белавиа и Флай Дубай.</p>
        </br>
        <p><b>Мне кажется это успех!</b></p>
        </br>
        <p>Так что выбираем свое идеальное направление на ближайший год и вперед!</p>`,
        img: ['top1.jpg', 'top2.jpg', 'top3.jpg'],
    },
    {
        slug: 'qatar-top-places',
        title: 'ТОП мест для посещения в Катаре по рекомендации нашего менеджера',
        text: `
        <p>Наша Татьяна не так давно вернулась из Катара, посмотрела страну со всех сторон и готова поделиться с вами своим личным топом мест для посещений в данной стране.</p>
        </br>
        <p>Из Минска полетная программа рассчитана на 9-10 ночей, поэтому времени во время отдыха предостаточно и для пляжа и для активных прогулок.</p>
        </br>
        <p><b>Что посмотреть в Катаре по рекомендации нашего менеджера:</b></p>
        </br>
        <ol>
        <li>Прогулочная улица «21 High Street»</li>
        </br>
        <li>Импровизированная деревня «Katara Cultural Village»</li>
        </br>
        <li>Прогулочная улица «Crystal Walk»</li>
        </br>
        <li>Набережная Корниш и морская прогулка на лодке Доу</li>
        </br>
        <li>Национальный музей Катара</li>
        </br>
        <li>Рынок Souq Waqif (включая магазин по продаже Соколов и соколиная клиника)</li>
        </br>
        <li>Бесплатный трамвай в районе Msheireb Downtown Doha</li>
        </br>
        <li>Аквапарк Meryal на острове Кетайфан</li>
        </br>
        <li>Парк атракционов Doha Quest</li>
        </br>
        <li>Сафари в пустыню</li>
        </br>
        <li>Villaggio Mall – катарская Венеция внутри торгового центра</li>
        </br>
        <li>"Венеция в Дохе" – это район Qanat Quartier на искусственном острове The Pearl-Qatar, который имитирует венецианский стиль с каналами, мостами и цветными домами.</li>
        </ol>`,
        img: ['kat1.jpg', 'kat2.jpg', 'kat3.jpg'],
    },
    {
        slug: 'phu-quoc-five-tips',
        title: 'Пять фишек, которые нужно знать, отправляясь на остров Фукуока',
        text: `
        <p>Собираетесь на остров Фукуока? Мы подготовили для вас пять важных советов, которые сделают ваш отдых ещё более комфортным и бесхлопотным!</p>
        </br>
        <ol>
        <li><b>Бесплатный зеленый автобус</b>
        <br/>На острове курсирует бесплатный зеленый автобус. Это отличный способ перемещаться по острову экономно и удобно.</li>
        </br>
        <li><b>Проверяйте депозит в отеле заранее</b>
        <br/>Обязательно заранее проверяем депозит в вашем отеле, так как часть отелей взимает депозит при заселении (сразу скажу: их немного, но они есть). И особенность депозита во Вьетнаме — берут в долларах, а отдают только в донгах.</li>
        </br>
        <li><b>Обмен валюты — выбирайте доллары</b>
        <br/>Что касается обмена валюты — брать с собой лучше доллары и крупные купюры от 2013 года выпуска. На купюры низкого номинала либо старого образца будет менее выгодный курс.</li>
        </br>
        <li><b>На рынке торгуемся</b>
        <br/>На рынке торгуемся, так как фикс прайса там не будет нигде. Если такой формат покупок вам не подходит, то просто отправляйтесь в супермаркет, где цены зафиксированы.</li>
        </br>
        <li><b>Языковой барьер — не проблема</b>
        <br/>Языкового барьера как такового нет, так как все местные ходят с переводчиком на телефоне и легко вас поймут. Общение не составит никаких сложностей!</li>
        </ol>
        </br>
        <p>Теперь вы готовы к незабываемому путешествию на Фукуока! 🌴</p>`,
        img: ['fuku1.jpg', 'fuku2.jpg', 'fuku3.jpg'],
    },
    {
        slug: 'abu-dhabi-f1',
        title: 'Индивидуальный тур "Формула 1 Гран При Финал Абу-Даби 2025"',
        text: `
<p>Гонки, Benson Boone, Metallica, Katy Perry - Эксклюзивный тур на главный уикенд года: Формула-1 в Абу-Даби.</p>
</br><p>Почувствуйте рев моторов, аромат скорости и атмосферу роскоши на финале Формулы-1 в Абу-Даби!</p>
</br><p>Мы организуем для вас индивидуальную поездку: лучшие места на трибунах, комфортные отели, Vip-сервис и вечеринки с мировыми артистами. Всё продумано до мелочей — вы отдыхаете, мы заботимся.</p>
        </br><ul>Вас ждёт не только захватывающая гонка на трассе Yas Marina, но и грандиозные концерты мировых звёзд:
        <li></br><b>4 декабря:</b> Откроет музыкальный уикенд восходящая звезда <b>Benson Boone</b> с хитами <b>Beautiful Things</b> и <b>Slow It Down</b>.</li>
</br>

<li>
<b>5 декабря:</b> На сцену выйдет многократный обладатель платиновых дисков <b>Post Malone</b>, известный своими хитами <b>Circles, Rockstar и Sunflower</b>.</li>
</br>
<li>
<b>6 декабря:</b> Легендарная рок-группа <b>Metallica</b> подарит незабываемое шоу с композициями <b>Enter Sandman и Nothing Else Matters</b>.</li>
</br>
<li>
<b>7 декабря:</b> Завершит музыкальный марафон поп-икона <b>Katy Perry</b> с её знаменитыми треками <b>Roar, Firework и Dark Horse</b>.</li>
</br>
</ul>
<h4><b>!!!5 ночей от 2690дол на человека (при двухместном размещении)!!!</b></h4>
<ul>В стоимость входит:</br>
</br><li>✅ Проживание 4 ночи в отеле Intercontinental Residences Abu Dhabi 5 (в просторных номерах с завтраками, расположен в центре города, рядом с набережной Corniche).</li>
</br><li>✅ Индивидуальный трансфер : Встреча в аэропорту Абу-Даби с табличкой, трансфер в отель и обратный трансфер в день вылета.</li>
</br><li>✅ Билет на финал Формулы-1 : Доступ на все 4 дня — Главная премиум трибуна (Main Premium Grandstand), центральный премиум-сектор — идеальный обзор на стартовую решётку, пит-лейн и финиш.</li>
</br><li>✅ Вход на все концерты Yasalam After-Race : Benson Boone, Post Malone, Metallica, Katy Perry Включён общий доступ, возможно добавление Golden Circle (фан зона ближе к сцене).</li>
</br><li>✅ Входные билеты в музеи и достопримечательности : Лувр Абу-Даби и Президентский дворец Qasr Al Watan.</li>
</br><li>✅ Прогулка по Pit Lane в четверг.</li>
</br><li>✅ Доступ в зону "оазис".</li>
</br><li>✅ Билет в тематический парк (на выбор): Ferrari World, Warner Bros или Yas Waterworld.</li>
</br><li>✅ Поддержка личного координатора на протяжении всей поездки.</li>
</ul>

<h5>Подробную программу можно утончить у наших менеджеров.</h5>`,
        img: ['ab1.jpg', 'ab2.jpg', 'ab3.jpg'],
    },
    {
        slug: 'hainan-island',
        title: 'ТОП 5 причин для посещения о.Хайнань!',
        text: `
        <ol xmlns='http://www.w3.org/1999/html'>
        <li>Пляжный рай и кристально чистая вода 
На острове несколько популярных курортных зон и каждый пляж удивителен и красив по своему.</li>
</br>

<li>Теплый климат круглый год
Мягкая и приятная погода делает Хайнань идеальным местом для отдыха в любое время года, с небольшой оговоркой. Январь - февраль это все таки зимние месяца для острова и температура воды в это время будет варьироваться от 20 до 23 градусов, поэтому данное время все таки больше подойдет для любителей нежаркой погоды.</li>
</br>
<li>Уникальная природа и природные достопримечательности
От национальных парков и тропических лесов до горячих источников и живописных гор — Хайнань предлагает богатство природных красот, которые вдохновляют и восхищают.</li>
</br>
<li>Кухня 
Яркое сочетание морепродуктов, тропических фруктов и свежих ингредиентов. Здесь популярны блюда из морепродуктов, такие как жареные креветки, рыба на гриле и супы с морским луком. Также широко распространены местные деликатесы с использованием кокосов, ананасов и других тропических фруктов. В то же время на о. Хайнань гораздо проще найти заведения, адаптированные по кухне к европейской, поэтому если вы путешествуете с детьми и все таки хотите посетить Азию - Китай отличное место.</li>
</br>
<li>Современная инфраструктура и комфортный отдых
На острове расположены роскошные отели, спа-центры, рестораны и развлекательные комплексы. Всё создано для того, чтобы ваш отдых был максимально приятным и беззаботным. Цены на такси низкие, хорошо развит городской транспорт, поэтому перемещение на острове не составит труда независимо от ваших предпочтений и бюджета.</li></ol>`,
        img: ['hn1.jpg', 'hn2.jpg', 'hn4.jpg', 'hn5.jpg'],
    },
    {
        slug: 'phu-quoc-tropical-paradise-direct-flights',
        title: 'Фукуок — тропический рай с прямыми рейсами из Москвы: откройте для себя уникальный остров Вьетнама',
        text: `
        <p>Если вы мечтаете о месте, где можно забыть о повседневной суете, насладиться природой и окунуться в атмосферу спокойствия и роскоши, то рады сообщить вам о возобновлении прямых чартерных рейсов на остров Фукуок.</p>
        </br>
<p><b>Почему именно Фукуок?</b></p>
⠀<br/>
<p>Фукуок — крупнейший остров Вьетнама, расположенный в южной части страны, в Сиамском заливе. Этот уголок природы славится своей богатой флорой и фауной, белоснежными пляжами и кристально чистыми водами. Он идеально подходит как для тех, кто ищет уединения и отдыха на берегу моря, так и для любителей активных водных развлечений.
</p>
⠀<br/>
<p><b>Особенности острова:</b></p>
⠀<ul>
<li>✅ Пляжи и вода: 
Белоснежные пляжи с мягким песком тянутся на километры вдоль побережья. Лазурные воды идеально подходят для плавания, сноркелинга и дайвинга. Особенно популярны такие места как Сао Ван, Дам Беа и Онг Лонг.
</li>
⠀
<li>✅ Подводный мир:
 Фукуок — настоящий рай для любителей подводных приключений. Красочные коралловые рифы и богатый морской мир делают его одним из лучших мест во Вьетнаме для дайвинга и сноркелинга.</li>
⠀
<li>✅ Природа и экотуризм:
 Тропические леса, водопады и заповедники позволяют познакомиться с богатой флорой и фауной острова. Национальный парк Фукуок — место обитания редких видов растений и животных.</li>
⠀
<li>✅ Культура и кухня:
 Уютные рыбацкие деревушки сохраняют традиционный колорит. Местная кухня порадует свежими морепродуктами, ароматными специями и уникальными блюдами вьетнамской кухни.</li>
⠀
<li>✅ Роскошные курорты:
 На острове расположены современные отели и виллы с великолепными видами на море, спа-комплексами и ресторанами высокой кухни. Это место идеально подходит для романтических отпусков, семейных путешествий или уединенного отдыха.</li>
⠀
</ul>

<p><b>Почему стоит выбрать прямой рейс?</b></p>
</br>
<p>Ранее путешествие на Фукуок требовало пересадок через Хошимин или Ханой, что увеличивало время в пути и создавало дополнительные хлопоты. Теперь же благодаря новым прямым рейсам из Москвы вы можете оказаться на острове всего за несколько часов — быстро, удобно и без лишних пересадок.</p>
</br>

<p><b>Лучшие сезоны для посещения:</b></p>
</br>
<ul>

<li>✅ Высокий сезон (ноябрь — апрель): Это самое популярное время для посещения острова. Погода сухая, солнечная и теплая — температура воздуха обычно держится в диапазоне +27…+32°C. Вода в море прогревается до +27…+29°C, что идеально подходит для купания, дайвинга и других водных развлечений. В этот период на острове меньше осадков, а погода стабильна.</li>
</br>
<li>✅ Дождливый сезон (май — октябрь): В это время возможны кратковременные ливни и повышенная влажность. Температура воздуха остается высокой (+28…+33°C), а море продолжает быть теплым. Однако стоит учитывать возможные кратковременные штормы или сильные дожди — это не мешает наслаждаться отдыхом, особенно если вы предпочитаете менее людные места.</li>
</ul>
</br>

<p>Если вы хотите максимально насладиться солнечной погодой и спокойной атмосферой — лучше планировать поездку на период с ноября по апрель. Для тех, кто любит более тихий отдых или ищет более выгодные цены — дождливый сезон тоже может стать хорошим выбором.</p>
</br>
<p><b>Планируйте свое путешествие</b></p>
</br>
<p>Если вы задумываетесь о следующем отпуске или просто мечтаете о месте для отдыха у моря — Фукуок уже ждет вас. Открытие новых прямых рейсов делает путешествие более доступным и комфортным. 
<b>Первый рейс состоится 09.11.2025 и предполагает 12 ночей на острове!</b></p>`,


        img: ['fuk1.jpg'],
    },
    {
        slug: 'not-only-beach-sri-lanka',
        title: 'Не пляжем единым!',
        text: `
        <p>Именно так можно сказать про Шри-Ланку.</p>
        </br>
<p>Она не столько и не только про пляжный отдых, сколько про удивительное сочетание возможностей океана с культурным наследием.</p>
⠀<br/>
<p>Итак, что нужно увидеть на Шри-Ланке если вы приехали не только к океану.</p>
⠀<ul>
<li>✅ Старинная крепость Сигирия.
В центре острова находится эта величественная крепость. Ставшая уже визитной карточкой.
Вход в замок был когда-то высечен в форме огромного льва.
Но сейчас можно увидеть лишь его лапы. Именно поэтому она называется «Львиная скала».</li>
⠀
<li>✅ Гора Пик Адама.
Практически культовое место.
Подъём занимает 4 часа и более 6000 ступеней.</li>
⠀
<li>✅ Водопад Сент-Клер.
Он течёт через живописные чайные плантации, а затем разбивается на два — большой и малый. Очень красиво 🔥</li>
⠀
<li>✅ Чайные плантации Нувара Элия.
Здесь стоит посетить чайную фабрику и приобрести различные сорта непередаваемо вкусного чая.</li>
⠀
<li>✅ Амбулувава.
Говорят, что это самая страшная башня на острове.
На самом деле башня построена специально для туристов в 2006 году.
И подниматься по ней довольно жутко. очень жутко.
Чем ближе к вершине, тем у'же становится винтообразная лестница.
А внизу прямо таки бездна. Но эти виды, это что-то невероятно завораживающее.
Отсюда, кстати, можно увидеть Пик Адама.</li>
⠀
<li>✅ Демодара. Девятиарочный мост.
Ооо, это, пожалуй, самое знаковое место Шри-Ланки.
Мост имеет 9 полётов и является местом притяжения всех, кто хочет сделать 🔥 фотографии. Кстати, именно его фотография расположена на упаковке чая Ahmad English Breakfast.</li>
</ul>
⠀</br>
А вы хотели бы посетить Шри-Ланку?`,
        img: ['sh1.jpg', 'sh2.jpg', 'sh3.jpg'],
    },
    {
        slug: 'top-beach-countries-rare-animals',
        title: 'ТОП пляжных стран, где можно увидеть редких животных 👇',
        text: `<p>Хотите получить порцию позитива? Отправляйтесь в гости к хвостатым в одну из этих стран. Улыбка до ушей и тепло в ❤️ вам обеспечены.</p>
⠀
<p><b>🦜 Бали</b>
<br/>Тут носороги, гиппопотамы, хищные кошки и ещё ~ 100 видов животных доступны на сафари. Стоит отправиться на дневную или ночную фотоохоту с кормлением. И пообедать в ресторане, наблюдая через панорамные окна за львами. А ещё лучше — остаться на ночёвку в этно-лодже.
Обязательно посетить Лес обезьян, где смышлёные макаки знают, как делать селфи.
И Парк птиц с самой большой в мире коллекцией пернатых.</p>
⠀
<p><b>🐘 Таиланд</b>
<br/>
И хозяева страны — слоники. Они обитают в многочисленных парках, но бережнее всего к ним относятся в реабилитационных центрах. Здесь можно их покормить, поучаствовать в сеансе Spa. Да, слоники тут принимают грязевое обтирание и душ.
Аж немного завидно 🤭
На некоторых фермах есть тигры, которые не прочь, чтобы им почесали за ушком.</p>
⠀
<p><b>🐒 Шри-Ланка</b><br/>Слонов здесь тоже можно увидеть даже целыми семьями. Умиляет, как маленьких детёнышей поучают строгие взрослые. А самое зрелищное — наблюдать за их купанием! И, конечно, на острове много любопытных обезьянок, древних черепах и редких крокодилов.</p>
⠀
<p><b>🦒 ОАЭ</b>
<br/>
Как всегда удивляет 🔥<br/>
Классный сафари-парк в Дубае, где дорожки с обдувом, тенты, увлажнители, мини-мобили.<br/>
Комфортно и зрелищно.<br/>
Тигры, кабаны, зебры, фламинго... С руки можно покормить жирафов и птиц.<br/>
А ещё впечатляющий океанариум с морскими животными в Абу-Даби, где проводят интересные научные экскурсии.</p>
⠀
<p><b>🐢 Сейшелы</b><br/>
Славятся гигантскими черепахами с панцирем до 1 м! Богатым миром пернатых, которые живут только здесь. Летучими мышами и пауками. И всё это в реальном ботаническом саду.</p>
⠀
<p><b>🐋 Маврикий</b><br/>
Сафари на сигвеях и дайвинг в море. Заплывы с дельфинами и наблюдение за акулами и кашалотами. Максимально близко!</p>
⠀
<p><b>🐼 Китай</b><br/>
Приехать и увидеть главный символ страны — чёрно-белых косолапых мишек. Застать панд за любимым завтраком из бамбуковых листьев. А после — за ленивыми валяниями и кувырканиями. Если визит ближе к осени, то есть вероятность увидеть новорождённых 😍</p>
⠀
<p>В общем, ми-ми-мишность гарантирована. Проверено ✔️</p>
</br>
<p>Пишите-звоните нам, подберём подходящий вариант и для вас.</p>`,
        img: ['a1.jpg', 'a2.jpg', 'a3.jpg'],
    },
];
